







import Component from "vue-class-component";
import Vue from "vue";

@Component({
  components: {},
  props:{
    isSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
})
export default class radio extends Vue {
}
